import { GlobalConstantsTableCols } from "globales-projekt-angular";

export class ConstantsTableColsErgebnisInvBedKb extends GlobalConstantsTableCols {

  static readonly KOSTENBLOCK: string = 'KOSTENBLOCK';
  static readonly GESAMT: string = 'GESAMT';
  static readonly JE_TIERPLATZ: string = 'JE_TIERPLATZ';

  static readonly HEADER_KOSTENBLOCK: string = 'HEADER_KOSTENBLOCK';
  static readonly HEADER_KOSTENBLOCK_GEB: string = 'HEADER_KOSTENBLOCK_GEB';

  public static getColumns(anzahlGeb: number): string[] {
    let cols: string[] = [this.KOSTENBLOCK];
    
    for (let i = 0; i < anzahlGeb; i++) {
      cols.push(this.GESAMT + "_" + i);
      cols.push(this.JE_TIERPLATZ + "_" + i);
    }
  
    return cols;
  }

  public static getColumnsHeader(anzahlGeb: number): string[] {
    let cols: string[] = [this.HEADER_KOSTENBLOCK];
    
    for (let i = 0; i < anzahlGeb; i++) {
      cols.push(this.HEADER_KOSTENBLOCK_GEB + "_" + i); 
    }
    
    return cols;
  }
}


